import classNames from 'classnames'
import * as React from 'react'
import { ChangeEvent } from 'react'
import { Control } from 'react-redux-form'

import Icon from 'components/Icon'
import { UI } from 'Icon/ui'

import './Checkboxes.scss'

interface CheckboxWrapperProps {
  inputName: string
  type?: string
  children?: React.ReactNode | undefined
}

const CheckboxWrapper: React.FC<CheckboxWrapperProps> = props => {
  const renderChildrenAsApi = () => {
    return React.Children.map(props.children, (child, index) => {
      const childElement = child as React.ReactElement<any>
      return React.cloneElement(childElement, {
        name: props.inputName,
        value: childElement.props.value ? childElement.props.value : index,
      })
    })
  }

  const className = classNames(
    'srprs-checkbox-wrapper',
    props.type ? `type-${props.type}` : '',
  )

  return <ul className={className}>{renderChildrenAsApi()}</ul>
}

enum CheckboxType {
  Box = 'checkbox-box',
}

interface CheckboxProps {
  model?: any
  name?: string
  type?: 'checkbox' | 'radio'
  onChange?: (event: string, checked: boolean) => void
  value?: string | number
  disabled?: boolean
  required?: boolean
  checked?: boolean
  checkboxType?: CheckboxType
  children?: React.ReactNode | undefined
}

const Checkbox: React.FC<CheckboxProps> = props => {
  const id = `${props.name}-${props.value}`
  const handleChange = (e: ChangeEvent<HTMLInputElement>) => {
    const target = e.currentTarget
    const value = target.value
    const checked = target.type === 'checkbox' ? target.checked : true

    if (props.onChange !== undefined) {
      props.onChange(value, checked)
    }
  }

  const Tag = props.model
    ? props.type === 'checkbox'
      ? Control.checkbox
      : Control.radio
    : 'input'
  const tagProps: { checked?: boolean } = {}
  if (Tag === 'input' && props.checked !== undefined) {
    tagProps.checked = props.checked
  }

  return (
    <li
      className={`srprs-checkbox ${
        props.checkboxType ? props.checkboxType : ''
      }`}
    >
      <Tag
        type={props.type}
        id={id}
        name={props.name}
        value={props.value}
        onChange={handleChange}
        model={props.model}
        disabled={props.disabled}
        required={props.required}
        {...tagProps}
      />
      <label htmlFor={id}>
        {props.children}
        <Icon icon={UI.check} />
      </label>
    </li>
  )
}

Checkbox.defaultProps = {
  type: 'checkbox',
}

export { CheckboxWrapper, Checkbox, CheckboxType }
